module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dialog', [_c('div', {
    staticClass: "flex flex-col w-full h-full"
  }, [_c('div', {
    staticClass: "flex flex-col w-full"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pl-5 pr-4 pt-3.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center justify-center rounded-full h-5 w-5 bg-purple-light"
  }, [_c('img', {
    staticClass: "w-3 h-3 pl-0.5",
    attrs: {
      "src": "/static/roundtable_icons/sequence_icon.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-gray-800"
  }, [_vm._v("Follow Up")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 font-manrope cursor-default"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": ("/static/roundtable_icons/" + _vm.type + "_icon_color.svg")
    }
  }), _vm._v(" "), (_vm.type !== '') ? _c('span', [_vm._v(_vm._s(_vm.type === 'written' ? 'Written RoundTable' : 'Verbal RoundTable'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800 cursor-default"
  }, [_c('img', {
    staticClass: "w-3 -mt-0.5",
    attrs: {
      "src": "/static/roundtable_icons/courses_icon.svg"
    }
  }), _vm._v(" "), (_vm.course) ? _c('span', [_vm._v(_vm._s(_vm.course.title))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-5"
  }, [(_vm.isSaving) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/cloud-upload.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-xs text-gray-800"
  }, [_vm._v("Saving Changes...")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer bg-gray-50 hover:bg-gray-100 text-base flex items-center justify-center hover:text-gray-800 text-gray-700",
    on: {
      "click": function($event) {
        return _vm.handleCloseDialog()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center px-5 relative w-full mb-2.5 mt-2.5"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "w-full text-3xl font-manrope font-bold text-gray-800 border-none bg-white py-1 outline-none",
    attrs: {
      "disabled": _vm.isLoading,
      "placeholder": _vm.isLoading ? 'Loading...' : 'Enter a title...'
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "bg-primary hover:bg-primary-dark rounded-md border border-solid border-primary text-white py-1.5 px-4",
    on: {
      "click": function($event) {
        return _vm.handleCreateRoundTable()
      }
    }
  }, [_vm._v("\n            Create\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between w-full bg-white h-11 focus-within:border-pinky border-b border-solid border-gray-200 pl-4 pr-5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 w-full font-manrope"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/sparkles.svg"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.revise.input),
      expression: "revise.input"
    }],
    ref: "genieRevise",
    staticClass: "w-full disabled:bg-white border-none",
    attrs: {
      "placeholder": "How can I help you make this discussion prompt better?"
    },
    domProps: {
      "value": (_vm.revise.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.revise, "input", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('button', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.revise.mode))]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-sm px-1 pt-0.5 pb-1 font-manrope max-h-96",
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    staticClass: "flex items-center space-x-1 justify-between hover:bg-gray-100 px-2.5 py-1 cursor-pointer rounded-md"
  }, [_c('span', [_vm._v("Prompt")]), _vm._v(" "), (_vm.revise.mode === 'Prompt') ? _c('i', {
    staticClass: "fa-solid fa-check text-gray-400"
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "flex justify-between space-x-1 text-gray-400 cursor-not-allowed items-center hover:bg-gray-100 px-2.5 py-1 rounded-md"
  }, [_c('span', [_vm._v("Selection")]), _vm._v(" "), (_vm.revise.mode === 'Selection') ? _c('i', {
    staticClass: "fa-solid fa-check text-gray-400"
  }) : _vm._e()])])]), _vm._v(" "), _c('button', {
    staticClass: "text-white w-8 h-6 rounded-lg flex justify-center items-center disabled:opacity-50 bg-pinky hover:bg-pinky-dark cursor-pointer",
    attrs: {
      "disabled": _vm.revise.input === '' || _vm.revise.input.length < 4 ? true : false
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-right-long"
  })])], 1)]), _vm._v(" "), (_vm.isLoading === true || _vm.isGenerating === true) ? _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "h-0.5 w-full bg-pink-100 overflow-hidden"
  }, [_c('div', {
    staticClass: "progress w-full h-full bg-pink-500 left-right"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow h-full w-full"
  }, [(_vm.type === 'written') ? _c('div', {
    staticClass: "w-full h-full"
  }, [_c('Editor', {
    ref: "editorWrittenPrompt",
    attrs: {
      "init": _vm.editor,
      "api-key": "no-api-key"
    },
    model: {
      value: (_vm.written.prompt),
      callback: function($$v) {
        _vm.$set(_vm.written, "prompt", $$v)
      },
      expression: "written.prompt"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'verbal') ? _c('div', {
    staticClass: "w-full h-full px-16 py-12"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-5 font-manrope mb-8"
  }, [_c('h3', {
    staticClass: "text-2xl text-gray-800 font-bold"
  }, [_vm._v("\n            Instructions\n          ")]), _vm._v(" "), (_vm.isLoading === false) ? _c('div', {
    staticClass: "outline-none text-base",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "textContent": _vm._s(_vm.verbal.instructions)
    },
    on: {
      "blur": _vm.handleChangeInstructions
    }
  }) : _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "space-y-2.5 animate-pulse w-full",
    attrs: {
      "role": "status"
    }
  }, [_c('div', {
    staticClass: "flex items-center w-full space-x-1"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-1"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-1"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5 font-manrope mb-8"
  }, [_c('h3', {
    staticClass: "text-2xl text-gray-800 font-bold"
  }, [_vm._v("\n            Content & Multimedia\n          ")]), _vm._v(" "), (_vm.isLoading === false) ? _c('div', {
    staticClass: "flex items-center space-x-2 w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resource.name),
      expression: "resource.name"
    }],
    staticClass: "w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary",
    attrs: {
      "placeholder": "Enter a Resource Name..."
    },
    domProps: {
      "value": (_vm.resource.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resource, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resource.url),
      expression: "resource.url"
    }],
    staticClass: "w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary",
    attrs: {
      "placeholder": "Enter a Resource URL..."
    },
    domProps: {
      "value": (_vm.resource.url)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddResource()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resource, "url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "disabled:opacity-50 bg-blueGray-800 rounded-md px-4 py-1.5 text-white",
    attrs: {
      "disabled": _vm.resource.name === '' && _vm.resource.url === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleAddResource()
      }
    }
  }, [_vm._v("Add")])]) : _vm._e(), _vm._v(" "), (_vm.verbal.resources.length > 0 && _vm.isLoading === false) ? _c('div', {
    staticClass: "w-full"
  }, [_c('ul', {
    staticClass: "flex flex-col"
  }, [_c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto",
    attrs: {
      "handle": ".handle"
    },
    on: {
      "start": function($event) {
        _vm.isDragResource = true
      },
      "end": function($event) {
        _vm.isDragResource = false
      }
    },
    model: {
      value: (_vm.verbal.resources),
      callback: function($$v) {
        _vm.$set(_vm.verbal, "resources", $$v)
      },
      expression: "verbal.resources"
    }
  }, _vm._l((_vm.verbal.resources), function(r, index) {
    return _c('li', {
      key: index,
      staticClass: "flex items-center justify-between space-x-2 text-base mb-1 text-blue-600"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('button', {
      staticClass: "h-8 w-8 hover:bg-gray-100 rounded-full handle"
    }, [_c('i', {
      staticClass: "fa-solid fa-grip-vertical text-blueGray-600"
    })]), _vm._v(" "), _c('a', {
      staticClass: "hover:underline",
      attrs: {
        "href": r.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('i', {
      staticClass: "fa-solid fa-arrow-up-right-from-square text-blue-500",
      staticStyle: {
        "font-size": "11px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('div', {
      staticClass: "w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out",
      class: {
        'bg-primary': r.is_active
      },
      attrs: {
        "title": "Hide Resource"
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeResourceStatus(r.id)
        }
      }
    }, [_c('div', {
      staticClass: "bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out",
      class: {
        'translate-x-3': r.is_active
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 rounded-full text-red-500",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteResource(r.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-square-minus text-xs"
    })])])])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoading === true) ? _c('div', [_c('div', {
    staticClass: "flex flex-col space-y-2.5 w-full animate-pulse"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-8/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-5/12"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5 font-manrope"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h3', {
    staticClass: "text-2xl text-gray-800 font-bold"
  }, [_vm._v("\n              Questions\n            ")])]), _vm._v(" "), (_vm.isLoading === false) ? _c('div', {
    staticClass: "flex items-center space-x-2 w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question.question),
      expression: "question.question"
    }],
    staticClass: "w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary",
    attrs: {
      "placeholder": "Enter a Question..."
    },
    domProps: {
      "value": (_vm.question.question)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddQuestion()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.question, "question", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-800 disabled:opacity-50 rounded-md px-4 py-1.5 text-white",
    attrs: {
      "disabled": _vm.question.question === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleAddQuestion()
      }
    }
  }, [_vm._v("Add")])]) : _vm._e(), _vm._v(" "), (_vm.verbal.questions.length > 0 && _vm.isLoading === false) ? _c('div', {
    staticClass: "w-full"
  }, [_c('ul', {
    staticClass: "flex flex-col"
  }, [_c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto",
    attrs: {
      "handle": ".handle-question"
    },
    on: {
      "start": function($event) {
        _vm.isDragQuestion = true
      },
      "end": function($event) {
        _vm.isDragQuestion = false
      }
    },
    model: {
      value: (_vm.verbal.questions),
      callback: function($$v) {
        _vm.$set(_vm.verbal, "questions", $$v)
      },
      expression: "verbal.questions"
    }
  }, _vm._l((_vm.verbal.questions), function(q, index) {
    return _c('li', {
      staticClass: "flex justify-between items-center space-x-2 text-base mb-1.5"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2 w-full"
    }, [_c('button', {
      staticClass: "h-8 w-8 hover:bg-gray-100 focus-within:outline-none rounded-full handle-question cursor-move"
    }, [_c('i', {
      staticClass: "fa-solid fa-grip-vertical text-blueGray-600"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (q.question),
        expression: "q.question"
      }],
      staticClass: "w-full border-none rounded",
      domProps: {
        "value": (q.question)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(q, "question", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-3"
    }, [_c('div', {
      staticClass: "w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out",
      class: {
        'bg-primary': q.is_active
      },
      attrs: {
        "title": "Hide Resource"
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeQuestionStatus(q.id)
        }
      }
    }, [_c('div', {
      staticClass: "bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out",
      class: {
        'translate-x-3': q.is_active
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 focus-within:border-red-500 focus-within:border focus-within:border-solid focus-within:outline-none rounded-full text-red-500",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteQuestion(q.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-square-minus text-xs"
    })])])])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoading === true) ? _c('div', [_c('div', {
    staticClass: "flex flex-col space-y-2.5 w-full animate-pulse"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-10/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-5/12"
  })])]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-120e4982!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/Sequences/Index.vue
// module id = 955
// module chunks = 61